module.exports = __webpack_public_path__ + "img/mediaset.b6c08484.png";